import * as React from 'react';
import { Box, Container, Grid } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import SowDialog from '../CreateDialogue/SowDialog';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import moment from "moment";
import SowAmendmentDialog from '../CreateDialogue/SowAmendmentDialog';
import EditSowDialog from '../EditDialogue/EditSowDialog';
import EditSowAmendmentDialog from '../EditDialogue/EditSowAmendmentDialog';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import { muiThemeDark } from '../../mui-theme-design';
import {logger, customBodyForExcelReport,handleExport,muiLoaderOptions, permissions} from '../../utils';
const ExcelJS = require('exceljs');

export default function SowTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState({});
    const [StatementsOfWork, setStatementsOfWork] = React.useState([]);
    const [amendmentsSow, setamendmentsSow] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    const handleDialogCallback = (childData) => {
        fetch("api/sow", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "sow": [{
                    "Name": childData.Name,
                    "CommonName": childData.CommonName,
                    "MGPT": childData.MGPT,
                    "OverTimeWeek": childData.OverTimeWeek,
                    "OverTimeHoliday": childData.OverTimeHoliday,
                    "OverTimeWeekEnd": childData.OverTimeWeekEnd,
                    "Link": childData.Link,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate,
                    "CostCenter": childData.CostCenter,
                    "PreviousSOWID": childData.PreviousSOWID,
                    "IsActive": childData.IsActive
                }]
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {
        fetch("api/sow", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "sow": {
                    "ID": childData.ID,
                    "Name": childData.Name,
                    "CommonName": childData.CommonName,
                    "MGPT": childData.MGPT,
                    "OverTimeWeek": childData.OverTimeWeek,
                    "OverTimeHoliday": childData.OverTimeHoliday,
                    "OverTimeWeekEnd": childData.OverTimeWeekEnd,
                    "Link": childData.Link,
                    "StartDate": childData.StartDate,
                    "EndDate": childData.EndDate,
                    "CostCenter": childData.CostCenter,
                    "PreviousSOWID": childData.PreviousSOWID,
                    "IsActive": childData.IsActive
                }
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const handleAmendmentCallback = (childData) => {
        fetch("api/sow_amendment", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "sow_amendment": childData
            })
        })
        logger(childData);
        setRefresh(true);
    };

    const handleEditAmendmentCallback = (childData) => {
        fetch("api/sow_amendment", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "sow_amendment": childData
            })
        })
        logger(childData);
        setRefresh(true);
    };

    React.useEffect(() => {
        if (refresh) {

            fetch('api/SOW', {
                method: 'Get',
            })
                .then(res => res.json())                
                .then(json => {
					setStatementsOfWork(json);
					setIsLoading(false);
				})
                .then(json => logger('getSOWs',json))

            fetch('api/sow_amendment', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setamendmentsSow(json))

            setRefresh(false);
        }
    })
    
    const columns1 = [
		{
            name: "",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <MuiThemeProvider theme={muiThemeDark}><>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen((prev) => ({[StatementsOfWork[dataIndex].Name]: !prev[StatementsOfWork[dataIndex].Name] }))}
                        >
                            {open[StatementsOfWork[dataIndex].Name] ? (
                                <KeyboardArrowUpIcon />
                            ) : (
                                <KeyboardArrowDownIcon />
                            )}
                            </IconButton> </></MuiThemeProvider>
                    );
                }

            }
        },
        {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                        	<EditSowDialog handleEditCallback={handleEditCallback} data={StatementsOfWork[dataIndex]}/>
                       </div>
                    );
                }

            }
        }
	];
    const columns2 = [
        {
            name: "MGPT",
            label: "MGPT",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "CommonName",
            label: "Short Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Link",
            label: "Sharepoint Link",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "StartDate",
            label: "Start Date",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(StatementsOfWork[dataIndex].StartDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "EndDate",
            label: "End Date",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(StatementsOfWork[dataIndex].EndDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
         {
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: true,
                filterList: [1],
                filterList: [1],
                customFilterListOptions:
                {
                    render: v => {
                        if (v === 0) {
                            return "Show InActive";
                        }
                        if (v === 1) {
                            return "Show Active";
                        }
                        return val;
                    },
                },
                filterOptions: {
                    renderValue: val => {
                        if (val === 0) {
                            return "InActive";
                        }
                        if (val === 1) {
                            return "Active";
                        }
                        return val;
                    }
                }, 
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            {(StatementsOfWork[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}

                        </div>
                    );
                }

            }
        } 
    ];

    const columns = permissions.CreateSOW === 1 ? [...columns1, ...columns2] : [...columns2];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('SowrowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('SowrowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();
	
	const options = {
		filter: true,
		filterType: 'dropdown',
		responsive: 'vertical',
		selectableRows: 'none',
		rowsPerPage: initialRowsPerPage,
		rowsPerPageOptions: [10, 20, 50, 100],
		selectableRows: 'none', textLabels: {
			toolbar: {
				search: "Search",
				downloadCsv: "Download Excel",
				print: "Print",
				viewColumns: "View Columns",
				filterTable: "Filter Table",
			},
		},
		onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}

			const customBuildBody = () => {
				const headers = customBuildHead();
				for (var i = 0; i < StatementsOfWork.length; i++) {
					var eachRow = data[i].data;
					eachRow[5] =  moment.utc(eachRow[5]).format("MM/DD/YYYY")
					eachRow[6] =  moment.utc(eachRow[6]).format("MM/DD/YYYY")
				}
				return customBodyForExcelReport({ data: data, headers: headers, columnIndexToRemove: 0, numberOfColumnsToRemove: 2 });
			};

			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({ rows: rows, headers: headers, filename: 'SOWList.xlsx', columnIndexToRemove: 0, numberOfColumnsToRemove: 2 })
			return false;
		},
		onFilterChange: (changedColumn, filterList) => {
			logger(changedColumn, filterList);
		},
		filterType: "dropdown",
		expandableRows: true,
		customToolbar: () => permissions.CreateSOW === 1 && !isLoading ? (
			<>
				<SowDialog handleDialogCallback={handleDialogCallback} />
				<SowAmendmentDialog handleAmendmentCallback={handleAmendmentCallback} />
			</>
		) : (<></>),
		renderExpandableRow: (rowData, rowMeta) => {
			logger("inside expand");
			logger(rowData, rowMeta);
			logger(StatementsOfWork);
			logger(StatementsOfWork[rowMeta.dataIndex]);

            


			return (
               
		  <TableRow style={{ backgroundColor: "#FFFFFF"}}>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                    <Typography variant="h6" gutterBottom component="div" style={{ backgroundColor: "aliceblue"}}>
                        Amendments for {StatementsOfWork[rowMeta.dataIndex].CommonName}
                    </Typography>
                    <Table size="small" aria-label="TimeLogged" style={{ backgroundColor: "#FFFFFF"}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Admin Actions</TableCell>
                                <TableCell>MGPT</TableCell>
                                <TableCell align="right">Amendment Date</TableCell>
                                <TableCell align="right">Comment</TableCell>                                                        
                                <TableCell align="right">Start Date</TableCell>
                                <TableCell align="right">End Date</TableCell>  
                            </TableRow>
                        </TableHead>
                            <TableBody>
                                {amendmentsSow.filter(obj => { return obj.SOWID === StatementsOfWork[rowMeta.dataIndex].ID }).map((amendment) => (
                                    <TableRow >
                                        <TableCell component="th" scope="row">
                                            <EditSowAmendmentDialog handleEditAmendmentCallback={handleEditAmendmentCallback} data={amendment}/>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {amendment.MGPT}
                                        </TableCell>                                                                
                                        <TableCell align="right">{ moment.utc(amendment.AmendmentDate).format("MM/DD/YYYY")}</TableCell>
                                        <TableCell align="right">{amendment.Comment}</TableCell>                                                                
                                        <TableCell align="right">{ moment.utc(amendment.StartDate).format("MM/DD/YYYY")}</TableCell>
                                        <TableCell align="right">{ moment.utc(amendment.EndDate).format("MM/DD/YYYY")}</TableCell>
                                    </TableRow>                                                        
                            ))}
                        </TableBody>
                    </Table>
                </TableCell>
                    </TableRow>
	  );
    },
    };
    
    
	options.onChangeRowsPerPage = (newRowsPerPage) => {
                saveRowsPerPage(newRowsPerPage);
            };
            
	return (
        
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="sowTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft SOW
                        </Typography>
                    }
                    data={isLoading ? [] :StatementsOfWork}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
        </Box>
        
    );
}